module.exports = __webpack_public_path__ + "static/media/ControlManifest.Input.64745a5e.xml";